import { render, staticRenderFns } from "./vpd-hero-image.vue?vue&type=template&id=7e8d1136&scoped=true"
import script from "./vpd-hero-image.vue?vue&type=script&lang=js"
export * from "./vpd-hero-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d1136",
  null
  
)

export default component.exports